var _defs, _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPoweredbyOcelotDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 920.01 267.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.72,140.15v11.18h-3.77v-28.57h10.54c3.13,0,5.58,.8,7.35,2.39,1.77,1.6,2.66,3.71,2.66,6.34,0,2.77-.87,4.91-2.6,6.41-1.73,1.5-4.22,2.25-7.45,2.25h-6.73Zm0-3.08h6.77c2.01,0,3.56-.47,4.63-1.42s1.61-2.32,1.61-4.12-.54-3.07-1.61-4.09c-1.07-1.02-2.54-1.55-4.41-1.59h-6.99v11.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.52,140.52c0-2.08,.41-3.95,1.23-5.61,.82-1.66,1.96-2.94,3.41-3.85,1.46-.9,3.12-1.35,4.99-1.35,2.89,0,5.23,1,7.01,3,1.79,2,2.68,4.66,2.68,7.99v.25c0,2.07-.4,3.92-1.19,5.56-.79,1.64-1.92,2.92-3.39,3.84-1.47,.92-3.16,1.37-5.07,1.37-2.88,0-5.21-1-6.99-3-1.79-2-2.68-4.65-2.68-7.95v-.25Zm3.65,.43c0,2.35,.55,4.25,1.64,5.67,1.09,1.43,2.55,2.14,4.39,2.14s3.31-.72,4.4-2.17c1.09-1.45,1.63-3.47,1.63-6.07,0-2.33-.55-4.21-1.66-5.66-1.11-1.45-2.57-2.17-4.41-2.17s-3.24,.71-4.34,2.14c-1.1,1.43-1.65,3.47-1.65,6.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.19,146.33l4.08-16.23h3.63l-6.18,21.23h-2.94l-5.16-16.09-5.02,16.09h-2.94l-6.16-21.23h3.61l4.18,15.89,4.94-15.89h2.92l5.04,16.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.4,151.73c-2.88,0-5.22-.95-7.02-2.83-1.81-1.89-2.71-4.42-2.71-7.58v-.67c0-2.11,.4-3.99,1.21-5.64,.8-1.65,1.93-2.95,3.37-3.88s3.01-1.4,4.7-1.4c2.76,0,4.91,.91,6.44,2.73,1.53,1.82,2.3,4.42,2.3,7.81v1.51h-14.38c.05,2.09,.66,3.78,1.83,5.07,1.17,1.29,2.66,1.93,4.46,1.93,1.28,0,2.37-.26,3.26-.79,.89-.52,1.67-1.22,2.33-2.08l2.22,1.73c-1.78,2.73-4.45,4.1-8.01,4.1Zm-.45-19.03c-1.47,0-2.69,.53-3.69,1.6s-1.61,2.56-1.84,4.48h10.63v-.27c-.1-1.84-.6-3.27-1.49-4.29-.89-1.01-2.09-1.52-3.61-1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.14,133.36c-.55-.09-1.14-.14-1.79-.14-2.38,0-4,1.01-4.85,3.04v15.07h-3.63v-21.23h3.53l.06,2.45c1.19-1.9,2.88-2.85,5.06-2.85,.71,0,1.24,.09,1.61,.28v3.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.91,151.73c-2.88,0-5.22-.95-7.02-2.83-1.81-1.89-2.71-4.42-2.71-7.58v-.67c0-2.11,.4-3.99,1.21-5.64,.8-1.65,1.93-2.95,3.37-3.88s3.01-1.4,4.7-1.4c2.76,0,4.91,.91,6.44,2.73,1.53,1.82,2.3,4.42,2.3,7.81v1.51h-14.38c.05,2.09,.66,3.78,1.83,5.07,1.17,1.29,2.66,1.93,4.46,1.93,1.28,0,2.37-.26,3.26-.79,.89-.52,1.67-1.22,2.33-2.08l2.22,1.73c-1.78,2.73-4.45,4.1-8.01,4.1Zm-.45-19.03c-1.47,0-2.69,.53-3.69,1.6s-1.61,2.56-1.84,4.48h10.63v-.27c-.1-1.84-.6-3.27-1.49-4.29-.89-1.01-2.09-1.52-3.61-1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.51,140.54c0-3.26,.77-5.88,2.32-7.86,1.54-1.98,3.56-2.97,6.06-2.97s4.45,.85,5.91,2.55v-11.07h3.63v30.14h-3.34l-.18-2.28c-1.45,1.78-3.47,2.67-6.06,2.67s-4.46-1.01-6.01-3.02-2.33-4.64-2.33-7.89v-.28Zm3.63,.41c0,2.41,.5,4.29,1.49,5.65s2.37,2.04,4.12,2.04c2.3,0,3.98-1.03,5.04-3.1v-9.75c-1.09-2-2.75-3-5-3-1.78,0-3.17,.69-4.16,2.06-.99,1.37-1.49,3.41-1.49,6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.98,140.96c0,3.24-.75,5.85-2.24,7.82-1.49,1.97-3.49,2.95-6,2.95-2.68,0-4.76-.95-6.22-2.85l-.18,2.45h-3.34v-30.14h3.63v11.24c1.46-1.82,3.49-2.73,6.06-2.73s4.6,.97,6.07,2.92,2.21,4.62,2.21,8.01v.31Zm-3.63-.41c0-2.47-.48-4.38-1.43-5.73-.95-1.35-2.33-2.02-4.12-2.02-2.39,0-4.11,1.11-5.16,3.34v9.18c1.11,2.22,2.84,3.33,5.2,3.33,1.74,0,3.09-.67,4.06-2.02,.97-1.35,1.45-3.38,1.45-6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.28,146.02l4.94-15.91h3.89l-8.54,24.51c-1.32,3.53-3.42,5.3-6.3,5.3l-.69-.06-1.35-.25v-2.94l.98,.08c1.23,0,2.19-.25,2.87-.75,.69-.5,1.25-1.41,1.7-2.73l.8-2.16-7.57-21h3.96l5.3,15.91Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M476.53,91.68c24.68,0,39.64,17.94,39.64,41.36s-14.97,41.47-39.64,41.47-39.76-17.94-39.76-41.47,14.97-41.36,39.76-41.36Zm0,70.03c16.68,0,24.9-11.65,24.9-28.67s-8.23-28.56-24.9-28.56-25.02,11.65-25.02,28.56,8.34,28.67,25.02,28.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M565.52,91.68c21.82,0,36.1,12.34,38.5,32.22h-14.74c-1.83-12.57-10.74-19.42-23.53-19.42-15.99,0-25.36,10.85-25.36,28.56s9.37,28.67,25.36,28.67c12.8,0,21.71-6.97,23.53-19.54h14.74c-2.4,19.99-16.68,32.33-38.5,32.33-24.79,0-39.87-17.94-39.87-41.47s15.08-41.36,39.87-41.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M615.45,92.82h54.49v12.79h-39.76v21.02h34.04v12.8h-34.04v21.13h39.76v12.79h-54.49V92.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M681.37,166.05V92.82h14.74v68.89l39.76-1.14v12.79l-45.81,1.14c-5.48,.11-8.68-2.97-8.68-8.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M775.62,91.68c24.68,0,39.64,17.94,39.64,41.36s-14.97,41.47-39.64,41.47-39.76-17.94-39.76-41.47,14.97-41.36,39.76-41.36Zm0,70.03c16.68,0,24.91-11.65,24.91-28.67s-8.23-28.56-24.91-28.56-25.02,11.65-25.02,28.56,8.34,28.67,25.02,28.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M885.06,105.62h-26.85v67.75h-14.74V105.62h-27.08v-12.79h68.66v12.79Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "312.72 152.27 292.92 152.27 292.92 148.46 307.22 148.46 300.89 131.64 312.93 100.47 331.71 100.47 331.71 104.28 315.54 104.28 304.97 131.66 312.72 152.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "306.03 118.94 298.99 104.1 298.99 82.68 311.24 82.68 332.35 101.13 329.84 104 309.81 86.49 302.8 86.49 302.8 103.24 309.47 117.31 306.03 118.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "334.68 173.95 322.92 173.95 312.92 160.79 297.46 160.79 297.46 156.98 314.81 156.98 324.81 170.14 332.32 170.14 334.53 165.72 327.12 157.98 329.88 155.35 339.14 165.03 334.68 173.95"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "356.08 160.25 341.4 145.98 347.98 131.48 340.75 104.28 332.19 104.28 324.96 131.48 331.54 146.02 316.27 160.1 313.68 157.3 326.94 145.08 320.92 131.82 329.26 100.47 343.67 100.47 352.01 131.82 345.98 145.12 358.73 157.52 356.08 160.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "380.36 152.27 360.21 152.27 367.96 131.66 357.39 104.28 341.22 104.28 341.22 100.47 360.01 100.47 372.04 131.64 365.71 148.46 380.36 148.46 380.36 152.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "367.31 119.44 363.81 117.93 370.14 103.28 370.14 86.49 363.14 86.49 343.67 103.98 341.12 101.14 361.68 82.68 373.95 82.68 373.95 104.07 367.31 119.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "350.01 173.95 338.25 173.95 333.79 165.03 343.06 155.35 345.81 157.98 338.4 165.72 340.61 170.14 348.12 170.14 358.13 156.98 376.29 156.98 376.29 160.79 360.02 160.79 350.01 173.95"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 308.77,
    y: 129.75,
    width: 14.17,
    height: 3.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 349.99,
    y: 129.75,
    width: 14.17,
    height: 3.81
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 318.67,
    y: 130.01,
    width: 3.81,
    height: 20.15,
    transform: "translate(-24.39 198.3) rotate(-33.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 342.19,
    y: 138.18,
    width: 20.15,
    height: 3.81,
    transform: "translate(42.21 358.22) rotate(-56.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 334.56,
    y: 124.98,
    width: 3.81,
    height: 11.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 328.26,
    y: 127.83,
    width: 3.81,
    height: 5.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 341.23,
    y: 127.83,
    width: 3.81,
    height: 5.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 334.56,
    y: 116.71,
    width: 3.81,
    height: 5.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 334.56,
    y: 138.95,
    width: 3.81,
    height: 5.98
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M340.84,194.03h-8.75l-3.66-12.08c-20.43-3.39-36.65-19.61-40.04-40.04l-12.08-3.66v-8.75l12.08-3.66c1.42-8.55,5.1-16.57,10.7-23.25l2.92,2.45c-5.4,6.45-8.87,14.24-10.03,22.54l-.17,1.21-11.69,3.54v3.09l11.69,3.54,.17,1.21c2.76,19.72,18.47,35.43,38.19,38.19l1.21,.17,3.54,11.69h3.09l3.54-11.69,1.21-.17c19.72-2.76,35.43-18.47,38.19-38.19l.17-1.21,11.69-3.54v-3.09l-11.69-3.54-.17-1.21c-1.19-8.47-4.77-16.4-10.36-22.92l2.89-2.48c5.8,6.76,9.6,14.92,11.05,23.66l12.08,3.66v8.75l-12.08,3.66c-3.39,20.43-19.61,36.65-40.04,40.04l-3.66,12.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.83,92.86c-3.83-1.72-7.89-2.89-12.07-3.47l-1.21-.17-3.54-11.69h-3.09l-3.54,11.69-1.21,.17c-4.02,.56-7.94,1.67-11.64,3.28l-1.52-3.49c3.64-1.59,7.48-2.72,11.42-3.37l3.66-12.08h8.75l3.66,12.08c4.11,.68,8.1,1.89,11.89,3.58l-1.56,3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314.68,88.28l-1.65-3.44c5.81-2.78,12.03-4.49,18.46-5.07l.34,3.79c-5.98,.54-11.76,2.13-17.16,4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.16,129.26l-3.79-.34c1.18-13.03,7.05-25.2,16.54-34.28l2.64,2.75c-8.82,8.44-14.28,19.76-15.38,31.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331.5,187.98c-26.11-2.37-46.77-23.03-49.14-49.14l3.79-.34c2.2,24.27,21.41,43.49,45.69,45.69l-.34,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M341.43,187.98l-.34-3.79c24.27-2.2,43.49-21.41,45.69-45.69l3.79,.34c-2.37,26.11-23.03,46.77-49.14,49.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M386.77,129.26c-1.13-12.43-6.82-23.97-16.02-32.48l2.59-2.8c9.9,9.15,16.02,21.56,17.23,34.94l-3.79,.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M358.96,88.63c-5.44-2.71-11.27-4.4-17.33-5.01l.38-3.79c6.52,.66,12.79,2.47,18.65,5.39l-1.7,3.41Z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoweredbyOcelotDark);
export default __webpack_public_path__ + "static/media/Poweredby-OCELOT-Dark.926773c50cd8721a0fca5cba35f8a899.svg";
export { ForwardRef as ReactComponent };